import React, { createContext, useContext, useMemo, useState } from 'react';
import { DEFAULT_WORKSPACE } from '../utils/constants';

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ children }) {
  const [workspace, setWorkspace] = useState(DEFAULT_WORKSPACE);

  const value = useMemo(() => ({ workspace, setWorkspace }), [workspace]);

  return (
    <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) throw new Error('useWorkspace outside WorkspaceProvider');
  return ctx;
}
